<template>
  <div class="container">
  </div>
</template>

<script type="text/babel">

export default {
  name: 'home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      console.log('init data')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus"  scoped>
.container
  min-height: 100%
  background-image: url('~assets/images/home-background.jpg')
  background-size:100%
</style>



// WEBPACK FOOTER //
// src/views/Home.vue